//------------------------------------------------------------------------------
// Execution conditions: on document ready
//------------------------------------------------------------------------------
document.addEventListener('DOMContentLoaded', function () {
    var userAgent = navigator.userAgent || navigator.vendor || window.opera;

    var location = 'https://banqi.onelink.me/oJyK/lyf6v53e';
    if (userAgent.match(/iPad/i) || userAgent.match(/iPhone/i) || userAgent.match(/Mac/i)) {
        location = "https://apps.apple.com/br/app/banqi-conta-digital/id1457893925";
    }

    var elements = document.getElementsByClassName('logincta');
    for (var i = 0; i < elements.length; i++) {
        elements[i].href = location;
    }
});

// Cookies
if (!localStorage.politicaCookies) {
    document.querySelector(".box-cookies").classList.remove('hide');
}

const acceptCookies = () => {
    document.querySelector(".box-cookies").classList.add('hide');
    localStorage.setItem("politicaCookies", "accept");
};

const btnCookies = document.querySelector(".btn-cookies");

btnCookies.addEventListener('click', acceptCookies);

// modal QR code
var modal = document.getElementById("myModal");
var modalPix = document.getElementById("myModalPix");
var modalAniver = document.getElementById("myModalAniver");
var btn = document.querySelectorAll(".login-qr");
var btnPix = document.querySelectorAll(".login-qr-pix");
var span = document.getElementsByClassName("close")[0];
var span2 = document.getElementsByClassName("close")[1];
var span3 = document.getElementsByClassName("close")[2];


btn.forEach(element => {
    element.onclick = function (e) {
        if (window.innerWidth >= 768) {
            e.stopPropagation();
            e.preventDefault();
            if (!location.pathname.startsWith("/usou-festou")) {
                modal.style.display = "block";
            } else {
                modalAniver.style.display = "block";
            }
        }
    };
});

btnPix.forEach(element => {
    element.onclick = function (e) {
        if (window.innerWidth >= 768) {
            e.stopPropagation();
            e.preventDefault();
            modalPix.style.display = "block";
        }
    };
});

span.onclick = function () {
    if (modal != null) {
        modal.style.display = "none";
    }

    if (modalAniver != null) {
        modalAniver.style.display = "none";
    }
}

if (span2 !== undefined) {
    span2.onclick = function () {
        modalPix.style.display = "none";
    }
}

window.onclick = function (event) {
    if (event.target == modal) {
        modal.style.display = "none";
    }

    if (event.target == modalPix) {
        modalPix.style.display = "none";
    }

    if (event.target == modalAniver) {
        modalAniver.style.display = "none";
    }
}